
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ActualizarClientesTiendaEnAPI, ObtenerClientesTiendasTipoIntegracionEnAPI, ObtenerClientesSocioEnAPI } from "../../action/actionCreatorsRequests";
import { MSGERROR, MSGOK, traducirPagina, obtenerUsuario } from "../../librerias/funciones"
import {
    PlusOutlined,
    SaveOutlined,
    EditOutlined,
    CloseOutlined
} from '@ant-design/icons';
import { Select, Card, Drawer, Modal, Button, Form, Input, Checkbox, Row, Col, Tabs } from 'antd';

import store from '../../store'
const { Option } = Select;
const { TabPane } = Tabs;
const CheckboxGroup = Checkbox.Group;

const FichaCrudTienda = ({ props, configApp }) => {
    const [hayCliente, setHayCliente] = React.useState(false);
    const [clientesTaller, setClientesTaller] = React.useState(false);


    const [tipoTienda, setTipoTienda] = React.useState([])

    const [payLoadLocal, setPayLoadLocal] = React.useState(
        {
            ID: 0,
            ID_SOCIO: 0,
            CODIGO_CLIENTE_SOCIO: -1,
            NOMBRE: "",
            ID_TIPO_INTEGRACION: -1,
            TANTO_PORCIENTO_INCREMENTO: 0,
            CORREO_RECEPCION_PEDIDOS: ""

        }
    )





    const ObtenerClientesTiendasTipoIntegracion = (REGSPAGE, PAGE, ORDERCOLUM, ORDERDIR, ID, NOMBRE) => {
        ObtenerClientesTiendasTipoIntegracionEnAPI(REGSPAGE, PAGE, ORDERCOLUM, ORDERDIR, ID, NOMBRE).then((licencia) => {
            if (licencia !== undefined && licencia !== null && licencia.REGISTROS !== null && licencia.REGISTROS.length > 0) {
                setTipoTienda(licencia.REGISTROS)
            } else {
                setTipoTienda(null)

            }
        })
    }




    const BuscarClientes = (ID_SOCIO) => {
        ObtenerClientesSocioEnAPI(ID_SOCIO).then((cli) => {
            if (cli !== undefined && cli !== null && cli.length > 0) {
                setClientesTaller(cli)
            } else {
                setClientesTaller(null)

            }

        })
    }


    const modificarRegistro = (PAYLOAD) => {
        let ACCION = props.ID_REGISTRO === 0 ? 0 : 1

        ActualizarClientesTiendaEnAPI(ACCION, PAYLOAD).then((licencia) => {
            props.ACTUALIZAR_TABLA();

            props.CERRAR_FICHA(false)

        })

    }



    if (!hayCliente && props.ABRIR_FICHA) {
        setHayCliente(true);

        ObtenerClientesTiendasTipoIntegracion(0, 1, 1, "D", null, "")


        if (props.ID_REGISTRO > 0) {
            //MODIFICAR
            payLoadLocal.ID = props.REGISTROS.ID
            payLoadLocal.ID_SOCIO = props.REGISTROS.ID_SOCIO
            payLoadLocal.CODIGO_CLIENTE_SOCIO = props.REGISTROS.CODIGO_CLIENTE_SOCIO
            payLoadLocal.NOMBRE = props.REGISTROS.NOMBRE
            payLoadLocal.ID_TIPO_INTEGRACION = props.REGISTROS.ID_TIPO_INTEGRACION
            payLoadLocal.TANTO_PORCIENTO_INCREMENTO = parseInt(props.REGISTROS.TANTO_PORCIENTO_INCREMENTO)
            payLoadLocal.CORREO_RECEPCION_PEDIDOS = props.REGISTROS.CORREO_RECEPCION_PEDIDOS

            setPayLoadLocal({ ...payLoadLocal })

        } else {
            //CREAR
            payLoadLocal.ID_SOCIO = props.ID_SOCIO
        }

        BuscarClientes(payLoadLocal.ID_SOCIO)
    } else {
        if (!props.ABRIR_FICHA && hayCliente) {
            setHayCliente(false);
        }
    }


    return (

        <Drawer
            width={600}
            onClose={() => { props.CERRAR_FICHA(false) }}
            visible={props.ABRIR_FICHA}
            placement={"right"}
            bodyStyle={{ padding: '0px' }}
            style={{ color: '#fff' }}>

            
            <div className='containerHeaderDrawer'>
                    <div className='itemHeaderDrawer1'>
                        <CloseOutlined onClick={(e) => {
                            if (props.TIPO === "MASTER") {
                                props.CERRAR.setState({ ABRIR_FICHA_TIENDA: false })
                            } else {
                                props.CERRAR_FICHA(false)
                            }
                        }}></CloseOutlined >
                        <div> {props.title}</div>
                    </div>

                    <div className='itemHeaderDrawer2'>

                    </div>
                </div>



            {payLoadLocal === null ?
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <h4>{traducirPagina("Info_sin_usuario")}</h4>
                </div>
                :
                <>
                    <div className="m-4 container_generico">

                        <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>

                            <Col md={24}>
                                <span>{`${traducirPagina("Cliente").toUpperCase()}:  `} </span>
                            </Col>

                            <Col md={24}>

                                {

                                    clientesTaller !== null &&
                                    <Select
                                        showSearch
                                        value={payLoadLocal.CODIGO_CLIENTE_SOCIO === -1 ? traducirPagina("Seleccione_cliente") : payLoadLocal.CODIGO_CLIENTE_SOCIO}
                                        size={"large"}
                                        placeholder={traducirPagina("Seleccione_cliente")}
                                        style={{ textAlign: 'left', width: '100%' }}
                                        optionFilterProp="children"
                                        onChange={(e) => {
                                            let REGISTRO = e === undefined || e === null ? -1 : e;
                                            if (REGISTRO !== -1) {
                                                let { Razon } = clientesTaller.find((registro) => registro.Codigo === REGISTRO)
                                                payLoadLocal.CODIGO_CLIENTE_SOCIO = REGISTRO
                                                payLoadLocal.NOMBRE = Razon

                                                setPayLoadLocal({ ...payLoadLocal })

                                            }

                                        }}
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {clientesTaller.length > 0 ?
                                            clientesTaller.map((registro) =>
                                                <Option key={registro.Codigo} value={registro.Codigo}>{`${registro.Codigo} - ${registro.Razon}`}</Option>
                                            )
                                            :
                                            null
                                        }
                                    </Select>

                                }


                                {/* 

                                <Input name="CODIGO_CLIENTE_SOCIO" value={payLoadLocal.CODIGO_CLIENTE_SOCIO} onChange={(e) => {
                                    payLoadLocal.CODIGO_CLIENTE_SOCIO = e.target.value
                                    setPayLoadLocal({ ...payLoadLocal })
                                }} />
                                */}


                            </Col>

                            <Col md={24}>
                                <span>{`${traducirPagina("Nombre_tienda").toUpperCase()}:  `} </span>
                            </Col>

                            <Col md={24} >
                                <Input name="NOMBRE" value={payLoadLocal.NOMBRE} onChange={(e) => {
                                    payLoadLocal.NOMBRE = e.target.value
                                    setPayLoadLocal({ ...payLoadLocal })
                                }} />
                            </Col>


                            <Col md={24}>
                                <span>{`${traducirPagina("Tipo_tienda").toUpperCase()}:  `} </span>
                            </Col>

                            <Col md={24}>


                                {

                                    tipoTienda !== null &&
                                    <Select
                                        showSearch
                                        value={payLoadLocal.ID_TIPO_INTEGRACION === -1 ? traducirPagina("Seleccion_tienda") : payLoadLocal.ID_TIPO_INTEGRACION}
                                        size={"large"}
                                        placeholder={traducirPagina("Seleccion_tienda")}
                                        style={{ textAlign: 'left', width: '100%' }}
                                        optionFilterProp="children"
                                        onChange={(e) => {
                                            let REGISTRO = e === undefined || e === null ? -1 : e;

                                            if(REGISTRO !== 1){
                                                payLoadLocal.TANTO_PORCIENTO_INCREMENTO = 0

                                            }

                                                payLoadLocal.ID_TIPO_INTEGRACION = REGISTRO
                                                setPayLoadLocal({ ...payLoadLocal })
                                            

                                        }}
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {tipoTienda.length > 0 ?
                                            tipoTienda.map((registro) =>
                                                <Option key={registro.ID} value={registro.ID}>{registro.DESCRIPCION}</Option>
                                            )
                                            :
                                            null
                                        }
                                    </Select>

                                }

                             

                            </Col>


                            <Col md={24}>
                                <span>{`${traducirPagina("Porcentaje_incremento").toUpperCase()}:  `} </span>
                            </Col>

                            <Col md={24} >
                                <Input disabled={payLoadLocal.ID_TIPO_INTEGRACION === 1 ? false : true} type='number' name="TANTO_PORCIENTO_INCREMENTO" value={payLoadLocal.TANTO_PORCIENTO_INCREMENTO} onChange={(e) => {
                                    payLoadLocal.TANTO_PORCIENTO_INCREMENTO = parseInt(e.target.value)
                                    setPayLoadLocal({ ...payLoadLocal })
                                }} />
                            </Col>

                            <Col md={24}>
                                <span>{`${traducirPagina("Correo_recepcion").toUpperCase()}:  `} </span>
                            </Col>

                            <Col md={24} >
                                <Input name="CORREO_RECEPCION_PEDIDOS" value={payLoadLocal.CORREO_RECEPCION_PEDIDOS} onChange={(e) => {
                                    payLoadLocal.CORREO_RECEPCION_PEDIDOS = e.target.value
                                    setPayLoadLocal({ ...payLoadLocal })
                                }} />
                            </Col>

                        </Row>
                    </div>

                    <div style={{display:'flex',justifyContent:'end'}} className="m-4" >
                        <button className={"botonNuevo"} style={{ backgroundColor: 'var(--azul-claro-serca)', color: 'rgb(255, 255, 255)' }}  onClick={(e) => modificarRegistro(payLoadLocal)}><SaveOutlined style={{ fontSize: '20px' }} /> <span style={{ verticalAlign: 'middle', fontSize: '16px' }}>{`${traducirPagina("Guardar_salir").toUpperCase()}  `} </span>  </button>
                    </div>
                </>
            }
        </Drawer >

    )
}

FichaCrudTienda.propTypes = {
    title: PropTypes.string,
    ABRIR_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,
    REGISTROS: PropTypes.object,

    ID_REGISTRO: PropTypes.number,
    ID_SOCIO: PropTypes.number,

    ACTUALIZAR_TABLA: PropTypes.func
};

const mapStateToProps = (state, props) => {
    return {
        configApp: state.configApp,
        props: props,

    };
}

export default connect(mapStateToProps)(FichaCrudTienda);